import React from 'react'
import type { ReportMessageContext } from '@warcarp/api-types'
import { MessageBubble } from '../game/MessageThread'

/** The saved evidence uses the same read-only bubble as the flagging form. */
export function ReportedMessageBubble({ message, topSpacing }: { message: Omit<ReportMessageContext, 'alreadyReported'>; topSpacing?: number }) {
  return <MessageBubble item={{ ...message, id: message.messageId }} isOwn={false} showMeta showAvatar={false} topSpacing={topSpacing} suppressTextSelection={false} readOnly />
}
